import { Component, Inject, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CareAnalyticsService } from '@challenger/care/services/care-analytics.service';
import { ThemeCare } from '@challenger6/vm-pattern-library/theme/themes';
import { ThemeService } from '@challenger6/vm-pattern-library/theme/theme.service';
import { filter } from 'rxjs/operators';
import { smartFooterInterface } from '@challenger/care/models/smart-footer.interface';
import { SmartFooterUtilityService } from '@challenger/care/services/smart-footer-utility.service';
import { IpIdentificationService } from '@challenger/care/services/ip-identification.service';
import { CampaignContentService } from '@challenger/care/services/campaign-content.service';
import { PAGE_TYPE } from './app.constants';
import { AuthService } from '@challenger/care/services/auth.service';
import { isPlatformBrowser } from '@angular/common';
import { FooterService } from '@challenger/care/services/footer.service';
import { AppLoadingService } from './common/services/app-loading.service';
import { HeaderVariant } from '@challenger/care/components/header-wrapper/header.types';

@Component({
  selector: 'vm-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  themeVariant: HeaderVariant = HeaderVariant.secondary;
  smartFooter: smartFooterInterface;
  isLoading = true;

  constructor(
    public themeService: ThemeService,
    private router: Router,
    private careAnalyticsService: CareAnalyticsService,
    private createSmartfooterObjectService: SmartFooterUtilityService,
    private ipIdentificationService: IpIdentificationService,
    private campaignContentService: CampaignContentService,
    private authService: AuthService,
    private footerService: FooterService,
    private appLoadingService: AppLoadingService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.appLoadingService.setTheme$.subscribe((themeVariant) => { this.themeVariant = themeVariant; });
    this.appLoadingService.showLoading$.subscribe((isLoading) => {         
      this.isLoading = isLoading;
    });

    this.themeService.setMainTheme(ThemeCare);

    this.footerService.getLinks().subscribe((result) => {
      result.data.footer.link = result.data.footer.link.map((link) => ({
        href: link.url,
        text: link.label,
      }));
      this.smartFooter = this.createSmartfooterObjectService.formatToSmartFooterObj(result.data.footer);
    });

    if (isPlatformBrowser(this.platformId)) {
      this.campaignContentService.captureCampaignCode();
      this.authService.initialise();
      sessionStorage.removeItem('sessionPreviousUrl');
      this.ipIdentificationService.findByIpAddress().subscribe(() => {
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
          this.onNavigationEnd.bind(this);
        });
        this.onNavigationEnd();
      });
    }
  }

  private onNavigationEnd() {
    if (!sessionStorage.getItem('sessionReferrerUrl')) {
      sessionStorage.setItem('sessionReferrerUrl', window.document.referrer);
    }
    this.careAnalyticsService.pageType = PAGE_TYPE[window.location.pathname] || PAGE_TYPE.default;
    this.careAnalyticsService.trackPageView('how-to', 1);
  }
}
